import React from "react";
import MovieExplorer from "./components/MovieExplorer";


function App(){

  return(
    <MovieExplorer />
  );
}

export default App;